import React, { useContext, useEffect, useState } from 'react'
import { FaFacebook } from "react-icons/fa";
import { TiSocialInstagramCircular } from "react-icons/ti";
import { RiTwitterXFill } from "react-icons/ri";
import { TiSocialYoutube } from "react-icons/ti";
import { TbWorldWww } from "react-icons/tb";
import { IoMdShareAlt } from "react-icons/io";
import { NavLink, useNavigate } from 'react-router-dom';
import { FaWhatsapp } from "react-icons/fa";
import { getAppData } from '../apiService';
import { ApiContext } from '../context/ApiContext';
import { FaTiktok } from "react-icons/fa";
import { MdLiveTv } from "react-icons/md";
import { EventsContext } from '../context/EventsContext';
import { ShimmerCircularImage, ShimmerText, ShimmerThumbnail } from 'react-shimmer-effects';
function Navbar2() {
    const { data,deferredPrompt } = useContext(ApiContext);
    const { setRadioData } = useContext(EventsContext)
    const navigate = useNavigate();
    // useEffect(() => {
    //   const fetchData = async () => {
    //     try {
    //       const result = await getAppData("/api.php?set=App&id=1");
    //     setData(result.app[0]);
    //     }  catch (err) {
    //       setError('Error fetching data. Please try again later.');
    //       console.error('Error:', err);
    //     } finally {
    //       setLoading(false);
    //     }

    //   };

    //   fetchData();
    // }, []);
    useEffect(() => {
        if (data) {
            console.log(data,"raduoData");
            
            setRadioData(data)
        }
    }, [data])

    if (!data) {
        return (
            <>
                <div className='Navbar2-main'>
                    <div className='Navbar2-main-inner'>
                        <div className='Navbar2-main-inner-logos'>

                            <ShimmerCircularImage size={35} />
                            <ShimmerCircularImage size={35} />
                            <ShimmerCircularImage size={35} />
                            <ShimmerCircularImage size={35} />
                            <ShimmerCircularImage size={35} />
                            <ShimmerCircularImage size={35} />
                            <ShimmerCircularImage size={35} />
                            {/* <ShimmerThumbnail height={25} rounded />
            <ShimmerThumbnail height={25} rounded />
            <ShimmerThumbnail height={25} rounded />
            <ShimmerThumbnail height={25} rounded />
            <ShimmerThumbnail height={25} rounded /> */}
                        </div>
                    </div>
                </div>
                {/* <div className="loader-container">
            <div className="dot-wave-loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div> */}
            </>
        );
    }
    const handleShare = async () => {
        if (deferredPrompt) {
        //   console.log("Install prompt is active, skipping share...");
          return; 
        }
    
        if (navigator.share) {
          try {
            const currentUrl = window.location.href
            await navigator.share({
              title: "Check this out!",
              text: "Here's something interesting for you.",
              url: currentUrl,
            });
          } catch (error) {
            console.error("Error sharing:", error);
          }
        } else {
          alert("Web Share API not supported on this browser.");
        }
      };

    return (
        <div className='Navbar2-main'>

            <div className='Navbar2-main-inner'>
                <div className='Navbar2-main-inner-logos'>
                    {data.facebook ? <NavLink to={data.facebook} target="_blank"><FaFacebook /></NavLink> : ""}
                    {data.instagram ? <NavLink to={data.instagram} target="_blank"><TiSocialInstagramCircular /></NavLink> : ""}
                    {data.whatsapp ? <NavLink to={"https://api.whatsapp.com/send?phone=" + data.whatsapp} target="_blank"><FaWhatsapp /></NavLink> : ""}
                    {data.twitter ? <NavLink to={data.twitter} ><RiTwitterXFill /></NavLink> : ""}
                    {data.youtube ? <NavLink to={data.youtube} target="_blank"><TiSocialYoutube /></NavLink> : ""}
                    {data.website ? <NavLink to={data.website} target="_blank"><TbWorldWww /></NavLink> : ""}
                    {data.tiktok ? <NavLink to={data.tiktok} target="_blank"><FaTiktok /></NavLink> : ""}
                    {/* {data.tv_stream?<NavLink to={data.tv_stream} target="_blank"><MdLiveTv /></NavLink>:""} */}
                    {/* {data.tv_stream?<MdLiveTv onClick={()=>{navigate("/videoplayer");}}/>:""} */}
                    <IoMdShareAlt className='share-btn' onClick={handleShare} />
                </div>
            </div>
        </div>
    )
}



export default Navbar2